import { render, staticRenderFns } from "./SidecartLineItem.vue?vue&type=template&id=4165f898&scoped=true&lang=pug"
import script from "./SidecartLineItem.vue?vue&type=script&lang=js"
export * from "./SidecartLineItem.vue?vue&type=script&lang=js"
import style0 from "./SidecartLineItem.vue?vue&type=style&index=0&id=4165f898&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4165f898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4165f898')) {
      api.createRecord('4165f898', component.options)
    } else {
      api.reload('4165f898', component.options)
    }
    module.hot.accept("./SidecartLineItem.vue?vue&type=template&id=4165f898&scoped=true&lang=pug", function () {
      api.rerender('4165f898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/cart/SidecartLineItem.vue"
export default component.exports